import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./styles/index.css";
import "./lib/i18n";
// Global form-validation copy. Must load before any schema validates.
import "./lib/validation";
import { App } from "./App";
import { watchSystemTheme } from "./lib/theme";

watchSystemTheme();

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
